<template>
  <div>

    <!-- 导航组件封装 -->
    <Navigation></Navigation>
    <div class="container-xl top">
      <div class="computer">
        <img src="../img/Fame6635.png" alt="">
      </div>
      <div class="move">
        <img src="../img/Fram489.png" alt="">
      </div>
    </div>
    <div class="container-xl">
      <div class="row advantage">
        <h2>我们的优势</h2>
        <div class="col-lg-4 team">
          <img src="../img/Frame 67906.png" alt="" />
          <h4>香港专业医疗团队</h4>
          <p>
            我们拥有来自香港的专业医疗团队和优质的港式医疗设备。携手香港大学牙科医生林教授，矫正全程一对一指导，效果保障。
          </p>
        </div>
        <div class="col-lg-4 team">
          <img src="../img/Frame 67961.png" alt="" />

          <h4>高科技智能3D取模</h4>
          <p>
            5 分钟快速检查，<br />
            全方位获取口腔数据
          </p>
        </div>
        <div class="col-lg-4 team">
          <img src="../img/Frame 67951.png" alt="" />
          <h4>AI 数字化矫正方案</h4>
          <p>
            根据检查结果模拟数据诊断分析，<br />
            为你定制精准高效的矫齿方案。
          </p>
        </div>
      </div>
    </div>
    <div class="container-xl">
      <div class="row prove">
        <div class="col-lg-6">
          <div class="prove1">
            <img src="../img/Mask Group.png" alt="" />
            <h3>TUV nord</h3>
            <h3>南德认证检测</h3>
            <p>
              be@me隐形矫正器采用德国进口<br />
              的创新安全材质，通过跨领域专家及实验室<br />
              认可的国际产品安全测试。
            </p>
          </div>
        </div>
        <div class="col-lg-6 prove2">
          <img src="../img/Group 6534.png" alt="" />
        </div>
      </div>
    </div>
    <div class="container-xl live">
      <h2>活出你的光芒</h2>
      <div class="row Yours">
        <div class="col-lg-3 lasting">
          <img src="../img/Frame 6796@2x.png" alt="" />
          <h4>舒适柔韧</h4>
          <p>
            创新材质具有超强弹性，<br />为牙齿移动提供轻柔持续的力度，<br />佩戴舒适且不易变形。
          </p>
        </div>
        <div class="col-lg-3 lasting">
          <img src="../img/Frame 6796_1@2x.png" alt="" />
          <h4>持久应力</h4>
          <p>
            持续提供精准的矫正力度，<br />
            让矫正更符合治疗周期。
          </p>
        </div>
        <div class="col-lg-3 lasting">
          <img src="../img/Frame 6796_2@2x.png" alt="" />
          <h4>抗撕裂性强</h4>
          <p>
            综合抗撕裂性较普通矫治资料提升30% <br />
            ，大幅减少断裂可能，摘带安心。
          </p>
        </div>
        <div class="col-lg-3 lasting">
          <img src="../img/Frame 6795@2x.png" alt="" />
          <h4>不易染色</h4>
          <p>德国进口的创新材质，抗染色效能<br />提升30%，佩戴过程不易变色</p>
        </div>
      </div>
    </div>
    <div class="container-xl shine">
      <div class="row">
        <div class="col-lg-6 Blooming">
          <h2>
            助你绽放 <br />
            独特光芒
          </h2>
          <p>
            我们拥有本地专业牙科团队和顶<br />级医疗设备，使医疗创新和个人<br />成长不再遥远。
          </p>
         <router-link to="/about"> <img src="../img/Buttonsaa.png" alt="" /></router-link>
        </div>
        <div class="col-lg-6 form">
          <img src="../img/Group7054.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 底部组件封装 -->
    <Bottom></Bottom>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation.vue";
import Bottom from "@/components/Bottom.vue";
export default {
  metaInfo:{
    link:[{
      rel:'canonical',
      href:'https://mybeame.com/advantage'
    },{
      rel:'alternate',
      href:'https://mybeame.com/advantage',
      hrefLang:'x-default'
    }
    ]
  },

  components: {
    Navigation,
    Bottom,
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}

.row {
  margin-left: 0;
  margin-right: 0;
}
.top {
  margin-top: 70px;
}
.move{
  display: none;
}
.computer>img{
 width: 100%;
}
.advantage {
  text-align: center;
  padding: 80px 0;
}
.advantage > h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
}
.team > h4 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}
.team > p {
  margin: auto;
  width: 58%;
}
.team > img {
  width: 30%;
  margin-bottom: 10px;
}
.prove {
  padding: 80px 0;
  text-align: center;
  background-image: url(../img/n3.png);
}
.prove1 > img {
  margin-bottom: 20px;
}
.prove1 > h3 {
  font-size: 36px;
  font-weight: 600;
}
.prove1 > p {
  margin-top: 15px;
  margin-bottom: 50px;
}
.prove2 > img {
  width: 70%;
}
.live {
  background-image: url(../img/Group7058.png);
  background-size: 100% 100%;
}
.live > h2 {
  margin-left: 50px;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
  margin-top: 50px;
}
.Yours {
  padding: 50px 0 200px 0;
  text-align: center;

  border-radius: 0 0 250px 0;
}
.lasting > img {
  width: 50%;
}
.lasting > h4 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}
.shine {
  padding: 80px 0;
  background-image: url(../img/n1.png);
}
.Blooming {
  text-align: center;
}
.Blooming > h2 {
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 60px;
}
.Blooming>a > img {
  width: 16%;
  margin-bottom: 40px;
}
.form {
  text-align: center;
}
.form > img {
  width: 100%;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 992px) {
  .advantage > h2 {
    font-size: 28px;
  }
  .team > img {
    width: 20%;
  }
  .team > p {
    width: 60%;
  }
  .team > h4 {
    font-size: 21px;
  }
  .live {
    padding-top: 50px;
    background-color: #f2f2f2;
    background-image: none;
  }
  .Yours {
    border-radius: 0;
  }
  .live > h2 {
    font-size: 29px;
    margin-left: 15px;
  }
  .lasting > img {
    width: 30%;
    margin: 10px 0;
  }
  .prove1 > h3 {
    font-size: 28px;
  }
  .prove2 > img {
    width: 85%;
  }
}
@media all and (max-width: 570px) {
  .advantage > h2 {
    font-size: 27px;
  }
  .team > img {
    width: 25%;
    margin: 10px 0;
  }
  .team > h4 {
    font-size: 19px;
  }
  .team > p {
    font-size: 15px;
  }
  .team > p {
    width: 75%;
  }
  .live {
    padding-top: 50px;
    background-color: #f2f2f2;
    text-align: center;
  }
  .live > h2 {
    font-size: 27px;
    margin-left: 0px;
    margin-bottom: 0px;
  }
  .Yours {
    border-radius: 0;
  }
  .lasting > h4 {
    font-size: 19px;
  }
  .lasting > p {
    font-size: 15px;
  }
  .lasting > img {
    width: 25%;
    margin: 10px 0;
  }
  .prove1 > img {
    width: 25%;
  }
  .prove2 > img {
    width: 90%;
  }
  .top {
    margin-top: 42px;
  }
   .move{
    display: block;
  }
  .computer{
    display: none;
  }
  .move>img{
    width: 97%;
  }
  .Blooming > h2{
    margin-top: 0px;
  }
}
</style>